import { createContext, useContext, useState, ReactNode } from "react";

type Space = "brand" | "community";

interface SpaceContextType {
  space: Space;
  setSpace: (space: Space) => void;
}

const SpaceContext = createContext<SpaceContextType>({
  space: "brand",
  setSpace: () => {},
});

export const SpaceProvider = ({ children }: { children: ReactNode }) => {
  const [space, setSpace] = useState<Space>("brand");
  return (
    <SpaceContext.Provider value={{ space, setSpace }}>
      {children}
    </SpaceContext.Provider>
  );
};

export const useSpace = () => useContext(SpaceContext);
